var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.12 70.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M57.17,7.18m5.95,13.34V65a5.45,5.45,0,0,1-5.44,5.44l-44.32-.33a5.44,5.44,0,0,1-5.43-5.44V59.49h2.65v5.13a2.8,2.8,0,0,0,2.79,2.8l44.32.33A2.81,2.81,0,0,0,60.48,65V23.13H46.27a6,6,0,0,1-6-5.95V3l-27-.31a2.77,2.77,0,0,0-2.75,2.78V35.69H7.93V5.42A5.42,5.42,0,0,1,13.35,0l29,.33h.62Zm-3.85,0L43,4.18v13a3.31,3.31,0,0,0,3.31,3.31Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 38.34,
    width: 55.4,
    height: 19.39,
    rx: 2.54,
    style: {
      fill: "#71c51a"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(6.19 53.97)",
    style: {
      fontSize: "16.465299606323242px",
      fill: "#fff",
      fontFamily: "Nunito-Black, Nunito Black",
      fontWeight: 800
    }
  }, "X", /*#__PURE__*/React.createElement("tspan", {
    x: 11.29,
    y: 0,
    style: {
      letterSpacing: "-0.007977240584165136em"
    }
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.58,
    y: 0,
    style: {
      letterSpacing: "-0.009993792107299816em"
    }
  }, "S"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 31.35,
    y: 0
  }, "X"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsx_icon.cda5456237f20e3bf572fdff8cef7b7a.svg";
export { ForwardRef as ReactComponent };